export default "__VITE_ASSET__WG6mzd4u__"